
const storageKey = 'steda:recently-viewed'


function readHandles (){
    try {
        const handles = JSON.parse(localStorage.getItem(storageKey) ?? '[]')
        return Array.isArray(handles) ? handles : []
    } catch {
        return []
    }
}


class Component
extends HTMLElement {

    connectedCallback (){

        const exclude = new Set(( this.dataset.exclude ?? '' ).split(',').filter(Boolean))
        const limit = Number(this.dataset.limit) || 4

        const handles = readHandles()
            .filter(( handle ) => ! exclude.has(handle) )
            .slice(0,limit)

        if( ! handles.length )
            return

        const handleIntersection = ( entries , observer ) => {

            if( ! entries[ 0 ].isIntersecting )
                return

            observer.disconnect()

            this.load(handles)
        }

        //  Beobachtet den Wrapper, das Element selbst ist bis zum
        //  Laden `hidden` und würde nie als sichtbar gemeldet.

        new IntersectionObserver(handleIntersection,{
            rootMargin : '0px 0px 400px 0px'
        }).observe(this.parentElement)
    }

    async load ( handles ){

        const root = window.Shopify?.routes?.root ?? '/'
        const list = this.querySelector('[data-product-tiles-list]')

        //  Reihenfolge der Handles beibehalten, gelöschte /
        //  nicht mehr veröffentlichte Produkte (404) auslassen.

        const cards = await Promise.all(handles.map(async ( handle ) => {
            try {

                const response = await fetch(`${ root }products/${ encodeURIComponent(handle) }?section_id=recently-viewed-card`)

                if( ! response.ok )
                    return null

                const html = document.createElement('div')
                html.innerHTML = await response.text()

                return html.querySelector('.product-tile')

            } catch ( exception ){
                console.error(exception)
                return null
            }
        }))

        const found = cards.filter(Boolean)

        if( ! found.length )
            return

        list.replaceChildren(...found)
        this.hidden = false
    }
}


customElements.define(
    'recently-viewed' ,
    Component
)
